import { render, staticRenderFns } from "./Chargebacks.vue?vue&type=template&id=21fcfef9&scoped=true&"
import script from "./Chargebacks.vue?vue&type=script&lang=js&"
export * from "./Chargebacks.vue?vue&type=script&lang=js&"
import style0 from "./Chargebacks.vue?vue&type=style&index=0&id=21fcfef9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fcfef9",
  null
  
)

export default component.exports